/**
 * Convert American odds to Decimal odds.
 * American -110 → Decimal 1.909
 * American +150 → Decimal 2.50
 */
export function americanToDecimal(american) {
  const n = Number(american);
  if (isNaN(n)) return null;
  if (n > 0) return +(n / 100 + 1).toFixed(3);
  return +(100 / Math.abs(n) + 1).toFixed(3);
}

/**
 * Format a price for display given the current odds format.
 */
export function formatPrice(american, format = 'american') {
  const n = Number(american);
  if (isNaN(n)) return '—';
  if (format === 'decimal') return americanToDecimal(n).toFixed(2);
  return n > 0 ? `+${n}` : `${n}`;
}

/**
 * Format a spread cell: point + price, e.g. "-3.5 (-110)"
 */
export function formatSpread(point, price, format = 'american') {
  if (point == null || price == null) return '—';
  const p = Number(point);
  const pointStr = p > 0 ? `+${p}` : `${p}`;
  return `${pointStr} (${formatPrice(price, format)})`;
}

/**
 * Format a total cell: "O 220.5 (-110)" or "U 220.5 (-110)"
 */
export function formatTotal(label, point, price, format = 'american') {
  if (point == null || price == null) return '—';
  return `${label} ${point} (${formatPrice(price, format)})`;
}
